module.exports = __webpack_public_path__ + "img/info-icon.614869e7.svg";